import {
  Input
} from "antd";

Input.defaultProps = Object.assign({}, Input.defaultProps, {
  autoComplete: "off",
});



// WEBPACK FOOTER //
// ./src/MInput.js